'use strict';

class ApiRequestError extends Error {
    constructor(message) {
        super(message);
        this.name = 'ApiRequestError';
    }
};

module.exports = {
    ApiRequestError
};



/** WEBPACK FOOTER **
 ** ./public/js/utils/error/ApiRequestError.js
 **/